import { createTryMeBubbleFrames } from "../../core/personality-keyframes.js";

export const meta = Object.freeze({
  id: "try-me",
  label: "Try me",
  duration: 3000,
  description: "Eine blaue „Try me“-Chatnachricht erscheint rechts neben Orbi, hält kurz und driftet weich nach oben aus.",
  tags: ["prompt", "cta", "chat", "message", "one-shot", "loopable"],
});

export async function run({ scene, animate }) {
  if (!scene?.tryMeBubble) {
    throw new Error("Die Try-me-Sequenz benötigt ihre Chat-Bubble in der Stage.");
  }

  const options = { duration: meta.duration, easing: "linear" };
  const animations = [animate(scene.tryMeBubble, createTryMeBubbleFrames(), options)];

  await Promise.allSettled(animations.map(({ finished }) => finished));
}
